import { GiftingStoreSlice } from './types';
import { reduxKey } from './constants';
import { createSelector } from 'reselect';

function getState(state: any): GiftingStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getUserGiftState = createSelector(
  [getState, (_, useridUuid: string) => useridUuid],
  (state, useridUuid) => state[useridUuid] ?? {}
);
